import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="page-navbar-space container" style={{ minHeight: "95vh" }}>
      <div className="d-flex align-items-center justify-content-center flex-column">
        <img src="/Assets/Img/404.png" alt="404" className="img-fluid" />
        <h1 className="display-1 fw-bold text-primary text-center">404</h1>
        <h2 className="display-5 text-center fw-semibold">Page Not Found</h2>
        <p className="lead text-muted text-center fw-medium">The page you are looking for does not exist.</p>
        <Link to="/" className="btn btn-primary  btn-lg mt-4">
          Go Home
        </Link>
      </div>
    </div>
  )
}
